module.exports = __webpack_public_path__ + "static/media/UoA.3ee6513d.png";